import {Injectable} from '@angular/core';
import {ParseApiService} from "./parse-api.service";
import {EMPTY, Observable, of, Subscription} from "rxjs";
import {
    arrayIsSet,
    GlobalVariablesService,
    PaginationParserequestType,
    paramsParseQuery
} from "./global-variables.service";
import {catchError, expand, map, startWith, switchMap} from "rxjs/operators";
import {PagePermission, PageType, UserPermissionsParse} from "../../ParseClass/user-permissions-parse";
import {
    ChangePermissionsPageType
} from "../../widget/form-field-assign-page-to-user/form-field-assign-page-to-user.component";

@Injectable({
    providedIn: 'root'
})
export class UserPermissionsService {
    subscriptions: Subscription | undefined = new Subscription()
    loadPermissionProject = false

    constructor(
        private parseApiService: ParseApiService,
        private globalVariable: GlobalVariablesService
    ) {

    }

    getProjectConfiguration$(progettoId: string): Observable<UserPermissionsParse[] | undefined> {
        const requestParams = paramsParseQuery({progettoId})
        return this.parseApiService.runCloudFunction('web_getProgettoPermissions', requestParams,).pipe(
            map(pConfigurations => {
                if (arrayIsSet(pConfigurations)) {
                    return pConfigurations.map(pConfiguration => {
                        return new UserPermissionsParse(pConfiguration)
                    })
                } else {
                    return undefined
                }
            })
        )
    }

    editUserPagePermission$(progettoId: string, userId: string, pagePermission: PagePermission): Observable<UserPermissionsParse[] | undefined> {
        const requestParams = paramsParseQuery({progettoId, userId, pagePermission})
        return this.parseApiService.runCloudFunction('web_editUserPagePermission', requestParams,).pipe(
            map(pagePermission => {
                if (pagePermission != null) {
                    return undefined
                } else {
                    return undefined
                }
            })
        )
    }

    editUserPagePermissions$(progettoId: string, userId: string, pagePermissions: PagePermission[]): Observable<UserPermissionsParse[] | undefined> {
        const requestParams = paramsParseQuery({progettoId, userId, pagePermissions})
        return this.parseApiService.runCloudFunction('web_editUserPagePermissions', requestParams,).pipe(
            map(pagePermission => {
                if (pagePermission != null) {
                    return undefined
                } else {
                    return undefined
                }
            })
        )
    }

    editUsersPagePermissions$(progettoId: string, pagePermissions: ChangePermissionsPageType[]): Observable<PaginationParserequestType<UserPermissionsParse[] | undefined>> {
        const fetchPage$ = (page = 0) => {
            const current = pagePermissions[page];
            const isLast = (page + 1) >= pagePermissions.length;
            const progress = Math.ceil((page + 1) / pagePermissions.length * 100)
            return this.editUserPagePermissions$(progettoId, current.userId, current.pagePermissions).pipe(
                map(values => {
                    return {
                        item: values,
                        progress,
                        nextPage: isLast ? undefined : (page + 1),
                        finished: isLast,
                    }
                }),
                catchError(error => {
                    console.log(error)
                    return of({
                        item: undefined,
                        progress,
                        nextPage: isLast ? undefined : (page + 1),
                        finished: isLast,
                        error
                    })
                })
            )
        }
        return fetchPage$(0).pipe(
            expand(({nextPage}) => nextPage ? fetchPage$(nextPage) : EMPTY)
        )
    }

    removeUserFromProject(progettoId: string, userId: string): Observable<UserPermissionsParse[] | undefined> {
        const requestParams = paramsParseQuery({progettoId, userId})
        return this.parseApiService.runCloudFunction('web_removeUserFromProject', requestParams,).pipe(
            map(pagePermission => {
                if (pagePermission != null) {
                    return undefined
                } else {
                    return undefined
                }
            })
        )
    }

    edtiUserInitialPage$(progettoId: string, userId: string, pageType: PageType): Observable<UserPermissionsParse[] | undefined> {
        const requestParams = paramsParseQuery({progettoId, userId, pageType})
        return this.parseApiService.runCloudFunction('web_editUserInitialPage', requestParams,).pipe(
            map(pagePermission => {
                if (pagePermission != null) {
                    return undefined
                } else {
                    return undefined
                }
            })
        )
    }

    getUserPermissionsForProject$(progettoId: string): Observable<PagePermission[] | undefined> {
        const requestParams = paramsParseQuery({progettoId})
        return this.parseApiService.runCloudFunction('web_getUserPermissionsForProject', requestParams,).pipe(
            map(pConfigurations => {
                if (arrayIsSet(pConfigurations)) {
                    return pConfigurations.map((pConfiguration: any) => {
                        return new PagePermission(pConfiguration)
                    })
                } else {
                    return undefined
                }
            })
        )
    }

    initChangePermissionInProject() {
        this.destroyChangePermissionInProject();
        this.subscriptions = this.globalVariable.changeProject$.pipe(
            startWith(undefined),
            switchMap(projectId => {
                this.globalVariable.permissionInProject = undefined;
                this.loadPermissionProject = true;
                if (projectId == null) {
                    return of(undefined)
                } else {
                    return this.getUserPermissionsForProject$(projectId)
                }
            })
        ).subscribe(permission => {
            if (arrayIsSet(permission)) {
                this.globalVariable.permissionInProject = permission
            } else {
                this.globalVariable.permissionInProject = undefined
            }
            this.loadPermissionProject = false;
        }, error => {
            console.log(error)
            this.loadPermissionProject = false;
            this.globalVariable.permissionInProject = undefined
        })
    }

    destroyChangePermissionInProject() {
        // if (this.subscriptions != null) {
        //     this.subscriptions?.unsubscribe()
        //     this.subscriptions = undefined;
        //     console.log('destroy')
        // }
    }
}
